module.exports = __webpack_public_path__ + "static/media/mandarin.ab27af59.svg";